<template>
  <div
    v-show="layout === 'landing'"
    class="landing-bg h-100 bg-gradient-primary position-fixed w-100"
  ></div>
  <sidenav v-if="showSidenav" />
  <main class="main-content position-relative max-height-vh-100 h-100">
    <navbar v-if="showNavbar" />
    <router-view />
    <app-footer v-show="showFooter" />
    <Vue3Snackbar top right :duration="4000" :groups="true"></Vue3Snackbar>
  </main>
</template>
<script>
import { activateDarkMode } from "@/assets/js/dark-mode";
import { mapGetters, mapState } from "vuex";
import { Vue3Snackbar } from "vue3-snackbar";
import Constants from "@/helpers/constants";
import Sidenav from "./shared/Sidenav";
import Navbar from "@/shared/Navbars/Navbar.vue";
import AppFooter from "@/shared/Footer.vue";
import emitter from "@/helpers/eventBus";

export default {
  name: "App",
  components: {
    Sidenav,
    Navbar,
    AppFooter,
    Vue3Snackbar,
  },
  computed: {
    ...mapState([
      "layout",
      "showSidenav",
      "showNavbar",
      "showFooter",
      "showConfig",
      "hideConfigButton",
    ]),
    ...mapGetters(["getError"]),
  },
  watch: {
    getError: {
      deep: true,
      handler: function (newError) {
        this.$snackbar.add({
          type: "error",
          text: newError.response.data.message || Constants.GENERIC_ERROR,
        });
      },
    },
  },
  mounted() {
    activateDarkMode();
    const appElement = document.getElementById("app");
    if (appElement) {
      appElement.addEventListener("scroll", this.handleScroll);
    }
  },
  beforeUnmount() {
    const appElement = document.getElementById("app");
    if (appElement) {
      appElement.removeEventListener("scroll", this.handleScroll);
    }
  },
  methods: {
    handleScroll(event) {
      // console.log("Scroll event detected in App.vue");
      const { scrollTop, scrollHeight, clientHeight } = event.target;
      if (this.$route.name === 'Leaderboard' && scrollTop + clientHeight >= scrollHeight - 200) {
        emitter.emit('load-more-data');
      }
    },
  },
};
</script>
